import { Button, CircularProgress } from '@mui/material'
import React from 'react'

export default function PintButton({ loading, download }) {
    return (
        <Button onClick={download} variant='contained' sx={{
            width: '140px',
            background: '#3364af57 0 0 no-repeat padding-box',
            border: '1px solid #3364af57',
            color: '#3364af',
            fontWeight: '700',
            borderRadius: '100px', ':hover': {
                background: '#3364af57 0 0 no-repeat padding-box',
            },
            height: '50px'
        }} > {loading ? <CircularProgress size={'18px'} color="inherit" /> : 'พิมพ์'}</Button >
    )
}
